// Added by Jonghyung Lee on 2020-10-12
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react'

interface TabPanelProps {
  index: number
  value: number
  children: React.ReactNode
}

const TabPanel: FC<TabPanelProps> = ({ index, value, children, ...props }) => {
  return (
    <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...props}>
      {children}
    </div>
  )
}

export default TabPanel
